"use client";

import React from "react";
import { Mic, Linkedin, ArrowRight, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "HAGARICast",
  description: "Insights profundos sobre liderança, mercado e carreira com grandes nomes do mundo corporativo. Um espaço para reflexões que transformam trajetórias.",
  icon: Mic,
  buttonText: "Ouvir Episódios",
  link: "#hagaricast"
}, {
  title: "Comunidade Executiva",
  description: "Expanda sua rede de contatos e participe de discussões estratégicas em nosso grupo exclusivo no LinkedIn, focado em longevidade profissional.",
  icon: Linkedin,
  buttonText: "Conectar na Rede",
  link: "https://wa.me/5511966187866",
  newTab: true
}];
const testimonials = [{
  quote: "A MASTERPRO+ transformou minha visão sobre longevidade na carreira. O nível do networking e as discussões estratégicas são incomparáveis no mercado brasileiro.",
  name: "Carlos Silva",
  role: "Diretor de Operações",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/avatar_carlos.png",
  initials: "CS"
}, {
  quote: "Os insights compartilhados no ecossistema são fundamentais para minhas decisões semanais. Uma verdadeira bússola para líderes que buscam inovação contínua.",
  name: "Ana Paula Mendes",
  role: "CEO & Fundadora",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/avatar_ana.png",
  initials: "AP"
}, {
  quote: "Um ambiente verdadeiramente focado no desenvolvimento da alta gestão. As conexões que fiz aqui abriram portas para parcerias estratégicas de alto valor.",
  name: "Roberto Almeida",
  role: "Conselheiro de Administração",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/avatar_roberto.png",
  initials: "RA"
}];
const partners = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_logo_1.png",
  alt: "Empresa Parceira 1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_logo_2.png",
  alt: "Empresa Parceira 2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_logo_3.png",
  alt: "Empresa Parceira 3"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_logo_4.png",
  alt: "Empresa Parceira 4"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_logo_5.png",
  alt: "Empresa Parceira 5"
}];
export default function MasterProEcosystem() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: featuresRef,
    isVisible: areFeaturesVisible
  } = useRevealOnScroll();
  const {
    ref: testimonialsRef,
    isVisible: areTestimonialsVisible
  } = useRevealOnScroll();
  const {
    ref: partnersRef,
    isVisible: arePartnersVisible
  } = useRevealOnScroll();
  return;
}